<template>
    <div>
        <compWrapper theme="primary" :title="$t('global.common.base_information',{defaultValue:'基本信息'})">
            <compFormQuery
                v-if="type=='query'"
                class="margin-top-15 margin-right-15 width-50per"
                :formdata="getBase"
                :value="formData"
                :labelWidth="150"
				placeholder="--"
                :col="1">
            </compFormQuery>

            <compFormEdit
                v-else
                class="margin-top-15 margin-right-15 width-50per"
                ref="editform"
                :formdata="getBase"
                v-model="formData"
                :labelWidth="150"
                :col="1">
            </compFormEdit>
            <template v-if="type!='query'" slot="footer">
				<vButton class="margin-right-20" theme="primary" @click="submit">{{$t('global.common.save', { defaultValue: "保存" })}}</vButton>
				<vButton class="margin-right-20" @click="cancel">{{$t('global.common.operation_cancel', { defaultValue: "取消" })}}</vButton>
			</template>
            <template v-else slot="footer">
				<vButton class="margin-right-20" @click="cancel">{{$t('', { defaultValue: "返回" })}}</vButton>
			</template>
        </compWrapper>
        <compWrapper :title="$t('global.common.operate_history', { defaultValue: '操作历史' })" theme="gray" v-if="type==='query'">
			<compLog class="margin-layout" :data="logList" :columns="logcolumn"></compLog>
		</compWrapper>

        <vLoading size="large" transfer :loading="loading"></vLoading>
    </div>
</template>

<script>
import { HttpGetAreaMaintainOne, HttpSaveAreaMaintainOne, HttpCarrierList } from '@/service/account';
import { HttpGetServiceList, HttpGetServiceProductList, HttpGetProductServiceByOrg } from "@/service/fedex";
import { mapGetters } from 'vuex';
import mixin from "../mixin"
export default {
    mixins: [mixin],
    props:['activeid','querytype'],
    data(){
        return {
            type: this.$route.params.type || this.querytype,
			id: this.$route.query.id || this.activeid,
            logList:[],
            carrierServiceList: [],
            formData:{},
            groupList: [],
            loading:false,
        }
    },
    components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		compFormEdit: () => import("@components/templates/formedit"),
        compLog: () => import("@components/templates/log"),
	},
    created(){
        this.getDetail();
    },
    computed:{
        ...mapGetters('dictionary', ['getOrgList', 'getCountryList', 'getCarrierAllList']),
        getBase(){
            return [
                {
                    // label: this.$t('fbb.alloment.carrier_code',{defaultValue:'承运商'}),
                    label: "承运商",
                    key: "carrierCode",
                    tag:'vSelect',
                    options:this.getCarrierAllList.map(item=>{
                        return {value: item.attach.carrierCode, label: item.label}
                    }),
                    // options:this.groupList,
                    props:{
                        filterable:true
                    },
                    on:{
                        'on-change':(val)=>{
                            if(val && this.type =='add'){
                                this.formData.carrierServiceCode = '';
                                let carrierId = this.getCarrierAllList.filter(item=>item.attach.carrierCode == val)[0].attach.id;
                                // HttpCarrierList({'search[EQ_carrierCode]': val})
                                HttpGetProductServiceByOrg({
                                // HttpOtherLogiServiceList({
                                    'search[EQ_carrierId]': carrierId,
                                    'search[EQ_active]':1,
                                })
                                .then(res=>{
                                    this.carrierServiceList = res.data;
                                },err=>{
                                    this.$VMessage.error(err.message);
                                })
                            }else{
                                this.carrierServiceList = [];
                            }
                        }
                    },
                    show: this.type == 'add',
                },
                {
                    label: "承运商",
                    key: "carrierCode",
                    show: this.type !== 'add',
                    query: true,
                },
                {
                    label: "承运商服务",
                    // label: this.$t('fbb.alloment.carrier_server', { defaultValue: '物流商服务' }),
                    key: 'carrierServiceCode',
                    tag:'Select',
                    options:this.carrierServiceList.map(item=>{
                        return {value: item.carrierServiceCode, label: item.carrierServiceCode}
                    }),
                    show: this.type == 'add',
                    required: false,
                },
                {
                    // label: this.$t('fbb.alloment.carrier_server', { defaultValue: '物流商服务' }),
                    label: "承运商服务",
                    key: "carrierServiceCode",
                    show: this.type !== 'add',
                    query: true,
                },
                {
                    label: this.$tc('',1,{defaultValue:'目的地国家'}),
                    key: "zoneRegionId",
                    tag:'vSelect',
                    options:this.getCountryList.map(item=>{
                        return {
                            value:item.attach.id,
                            label:item.label
                        }
                    }),
                    props:{
                        filterable:true
                    },
                     query:this.type!='add',
                },
                {
                    label: this.$tc('',1,{defaultValue:'发货地国家'}),
                    key: "shipRegionId",
                    tag:'vSelect',
                    options:this.getCountryList.map(item=>{
                        return {
                            value:item.attach.id,
                            label:item.label
                        }
                    }),
                    props:{
                        filterable:true
                    },
                     query:this.type!='add',
                },
                {
                    label: this.$t('fbb.settlement.shipPostal',{defaultValue:'发货地邮编'}),
                    key: "startLocation",
                     query:this.type!='add',
                },
                {
                    label: this.$t('fbb.settlement.zoneCode',{defaultValue:'分区代码'}),
                    key: "zoneCode",
                },
                {
                    label: this.$t('fbb.settlement.ruleRangeMin',{defaultValue:'目的地邮编范围最小值'}),
                    key: "ruleRangeMin",
                },
                {
                    label: this.$t('fbb.settlement.ruleRangeMax',{defaultValue:'目的地邮编范围最大值'}),
                    key: "ruleRangeMax",
                },
            ]
        },
    },
    methods:{
        // getOrgGroupList() {
        //     HttpGetServiceList({
        //         customerId: global.SYSID,
        //     }).then(
        //         (res) => {
        //             this.groupList = res.data.map(item => {
        //                 return {
        //                     value: item.carrierGroupCode,
        //                     label: item.carrierGroupCode,
        //                     attach: item
        //                 };
        //             });
        //         },
        //         (err) => {
        //             this.$VMessage.error(err.message);
        //         }
        //     );
        // },
        getDetail(){
            // if(this.type == 'add') this.getOrgGroupList();
            if(this.type == 'add') return;
            this.loading = true;
            HttpGetAreaMaintainOne({
                id:this.id,
            }).then(res=>{
                // HttpCarrierList({'search[EQ_carrierCode]': res.data.carrierZonesEntity.carrierCode}).then(res=>{
                //     this.loading = false;
                //     this.carrierServiceList = res.data;
                // },err=>{
                //     this.loading = false;
                //     this.$VMessage.error(err.message);
                // })
                this.formData = res.data.carrierZonesEntity;
                this.logList = res.data.updateLogEntities;
                this.loading = false;
            },err=>{
                this.$VMessage.error(err.message)
                this.loading = false;
            })
        },
        async submit(){
            const valid = await this.$refs.editform.validate()
            if (!valid) return;

            this.loading = true;
            HttpSaveAreaMaintainOne({
                id:this.id,
                carrierCode:this.formData.carrierCode,
                carrierServiceCode: this.formData.carrierServiceCode,
                zoneRegionId:this.formData.zoneRegionId,
                shipRegionId:this.formData.shipRegionId,
                startLocation:this.formData.startLocation,
                zoneCode:this.formData.zoneCode,
                ruleRangeMin:this.formData.ruleRangeMin,
                ruleRangeMax:this.formData.ruleRangeMax,
            }).then(res=>{
                this.$VMessage.success(res.message)
                this.loading = false;
                this.cancel()
            },err=>{
                this.$VMessage.error(err.message)
                this.loading = false;
            })
        },
        cancel(){
            this.$router.push({ name: 'carrierareamaintainList' });
        }
    }
}
</script>
